module.exports = "https://trybtryb-legacy.web.app/img/youtube.df787dde.svg";